import { useEffect, useState } from "react";

const RedirectScreen = () => {
  const [redirectUrl, setRedirectUrl] = useState(null);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let url = process.env.REACT_APP_LANDING_PAGE;

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      url = process.env.REACT_APP_APPSTORE || url;
    } else if (/Android/i.test(userAgent)) {
      url = process.env.REACT_APP_PLAYSTORE || url;
    }

    setRedirectUrl(url);

    if (url) {
      window.location.href = url;
    }
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f9fafb",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <p style={{ marginBottom: "20px", fontSize: "1rem", color: "#374151" }}>
        Redirigiendo...
      </p>
      {redirectUrl && (
        <a
          href={redirectUrl}
          style={{
            padding: "12px 20px",
            backgroundColor: "#2563eb",
            color: "white",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "bold",
            transition: "background 0.3s",
          }}
          onMouseEnter={(event) => {
            event.currentTarget.style.backgroundColor = "#1d4ed8";
          }}
          onMouseLeave={(event) => {
            event.currentTarget.style.backgroundColor = "#2563eb";
          }}
        >
          Ir ahora
        </a>
      )}
    </div>
  );
};

export default RedirectScreen;
